import { goto } from '$app/navigation';
import { get } from 'svelte/store';
import { KYCCategoriesName } from './enums/KYC';
import {
	getIdentityQuestions,
	getCompanyQuestions,
	getSimulatorQuestions,
	getBeneficiaryQuestion,
	getSignatureQuestions
} from './KYCQuestions';
import type { AccountModel } from './models/api/AccountModel';

import type { KYCModel } from './models/api/KYCModel';
import type { PhysicalPersonPartner } from './models/api/PhysicalPersonPartner';
import { urls } from './urls';
import { t } from 'svelte-i18n';
import { OperationRegulationsEnum } from '@app/models/api/enums/OperationRegulationsEnum';

export const configIdentity = (user: AccountModel): KYCModel => {
	const $t = get(t);

	return {
		name: KYCCategoriesName.Identity,
		introduction: {
			id: 1,
			title: $t('kyc.introductions.identity.title'),
			subTitle: $t('kyc.introductions.identity.subTitle'),
			isVisible: true,
			itemsList: $t('kyc.introductions.identity.itemsList'),
			questionMark: $t('kyc.introductions.identity.questionMark')
		},

		questions: getIdentityQuestions(user)
	};
};

export const configCompany = (user: AccountModel): KYCModel => {
	return {
		name: KYCCategoriesName.Company,
		questions: getCompanyQuestions(user)
	};
};
export const configSimulator = (user: AccountModel): KYCModel => {
	const $t = get(t);
	return {
		name: KYCCategoriesName.Simulator,
		introduction: {
			id: 2,
			title: $t('kyc.introductions.simulator.title'),
			isVisible: true,
			itemsList: $t('kyc.introductions.simulator.itemsList'),
			questionMark: $t('kyc.introductions.simulator.questionMark'),
			text: $t('kyc.introductions.simulator.text')
		},
		questions: getSimulatorQuestions(user)
	};
};

export const configSignature = (user: AccountModel): KYCModel => {
	return {
		name: KYCCategoriesName.Signature,
		questions: getSignatureQuestions(user)
	};
};

export const configFinish = (
	user: AccountModel,
	regulation: OperationRegulationsEnum
): KYCModel => {
	const $t = get(t);
	const buttonProps = (): { label: string; action: () => Promise<void> } => {
		return user.privateOperationID
			? {
					label: $t('kyc.introductions.finish.buttonTextPrivateOperation'),
					action: () => goto(urls.PROJECT.INDEX(user.privateOperationID.toString()))
				}
			: regulation === OperationRegulationsEnum.PSI
				? {
						label: $t('register.confirmation.backToHome'),
						action: () => goto(urls.HOME)
					}
				: {
						label: $t('kyc.introductions.finish.buttonText'),
						action: () => goto(urls.PROJECTS[regulation])
					};
	};

	return {
		name: KYCCategoriesName.Finish,
		introduction: {
			id: 3,
			title: $t('kyc.introductions.finish.title', {
				values: { firstName: user.identity?.firstName }
			}),
			isVisible: true,
			text: $t('kyc.introductions.finish.text'),
			buttonLabel: buttonProps().label,
			buttonAction: buttonProps().action
		},
		questions: []
	};
};

export const configBeneficiary = (
	beneficiary?: PhysicalPersonPartner,
	disabledOption?: boolean
): KYCModel => {
	return {
		questions: getBeneficiaryQuestion(beneficiary, disabledOption)
	};
};
